// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.support.enums.RentalManagerSupportHelpCategory

export enum RentalManagerSupportHelpCategory {
  INSURANCE_PRODUCTS = 'INSURANCE_PRODUCTS',
  MY_ACCOUNT = 'MY_ACCOUNT',
  MY_LISTING = 'MY_LISTING',
  RENTAL_TOOLS = 'RENTAL_TOOLS',
  ZILLOW_PRODUCTS = 'ZILLOW_PRODUCTS',
}

export const RentalManagerSupportHelpCategory_values = [
  RentalManagerSupportHelpCategory.INSURANCE_PRODUCTS,
  RentalManagerSupportHelpCategory.MY_ACCOUNT,
  RentalManagerSupportHelpCategory.MY_LISTING,
  RentalManagerSupportHelpCategory.RENTAL_TOOLS,
  RentalManagerSupportHelpCategory.ZILLOW_PRODUCTS,
] as const;
